module.exports = __webpack_public_path__ + "static/media/cardif_boxed.18c8a829.svg";